import React, { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import UserList from '../components/users/UserList';
import UserForm from '../components/users/UserForm';
import useAuth from '../hooks/useAuth';
import { useLocation } from 'react-router-dom';

const UserManagement = () => {
    const { isAdmin, isManager } = useAuth();
    const [view, setView] = useState('list');
    const [selectedUserId, setSelectedUserId] = useState(null);

    const location = useLocation();
    useEffect(() => {
        handleCancel(); // remet view='list' + selectedProductId=null
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.key]);

    // Vérifier si l'utilisateur est autorisé à accéder à cette page
    if (!isAdmin && !isManager) {
        return (
            <Container>
                <div className="alert alert-danger mt-4">
                    Vous n'êtes pas autorisé à accéder à cette page.
                </div>
            </Container>
        );
    }

    const handleAddUser = () => {
        setSelectedUserId(null);
        setView('form');
    };

    const handleEditUser = (userId) => {
        setSelectedUserId(userId);
        setView('form');
    };

    const handleCancel = () => {
        setView('list');
        setSelectedUserId(null);
    };

    const handleSuccess = () => {
        setView('list');
        setSelectedUserId(null);
    };

    

    return (
        <Container fluid>
            <div className="d-flex justify-content-between align-items-center mb-4">
                <h1 className="h3">Gestion des utilisateurs</h1>
            </div>

            {view === 'list' ? (
                <UserList
                    onAddUser={handleAddUser}
                    onEditUser={handleEditUser}
                />
            ) : (
                <UserForm
                    userId={selectedUserId}
                    onCancel={handleCancel}
                    onSuccess={handleSuccess}
                />
            )}
        </Container>
    );
};

export default UserManagement;